export enum EValuationTabs {
  PriceDynamic = '1',
  SalesDynamic = '2',
}
